import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';

export class ApprovalScopeCustomFieldOptionModel {
  label: string = '';
  value: string = '';
  order: number = 0;

  static create(input: any): ApprovalScopeCustomFieldOptionModel {
    return ObjectMapper.deserialize<ApprovalScopeCustomFieldOptionModel>(
      ApprovalScopeCustomFieldOptionModel,
      input || {}
    );
  }
}

export class ApprovalScopeCustomFieldModel
  extends Model
  implements IModel<ApprovalScopeCustomFieldModel>
{
  fieldId: string = '';
  approvalScopeItemId: string = '';
  key: string = '';
  label: string = '';
  inputType: string = '';
  required: boolean = false;
  order: number = 0;
  value: string = '';
  readOnly: boolean = false;
  options: ApprovalScopeCustomFieldOptionModel[] = [];

  static create(input: any): ApprovalScopeCustomFieldModel {
    if ('options' in (input || {})) {
      input.options = (input.options || []).map(ApprovalScopeCustomFieldOptionModel.create);
    }

    const model = ObjectMapper.deserialize<ApprovalScopeCustomFieldModel>(
      ApprovalScopeCustomFieldModel,
      input || {}
    );

    model.readOnly = input?.readOnly === true || input?.ReadOnly === true;

    return model;
  }
}
